import { render } from "./HouseCard.vue?vue&type=template&id=22b5d452&scoped=true&ts=true&lang=pug"
import script from "./HouseCard.vue?vue&type=script&lang=ts&setup=true"
export * from "./HouseCard.vue?vue&type=script&lang=ts&setup=true"

import "./HouseCard.vue?vue&type=style&index=0&id=22b5d452&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22b5d452"]])

export default __exports__